/**
 * Labstep
 */

import { Filter } from 'labstep-web/constants/filters';

export const bulkActions = [
  'assign',
  'delete',
  'share',
  'transfer_ownership',
];

export const filters = [
  Filter.created_by,
  Filter.assigned_to,
  Filter.date_range,
  Filter.deleted,
];
